<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="明细列表" @click-left="onClickLeft" @click-right="goIndex()" />
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item v-for="(view,index) in list" :name=index title="列表数据">
        <van-field v-model="view.item.no" label="商品编号" name="商品编号" readonly />
        <van-field v-model="view.item.name" label="商品名称" name="商品名称" readonly />
        <van-field v-model="view.pack.specification" label="包装规格" name="包装规格" readonly />
        <van-field v-model="view.lot.no" label="批号" name="批号" readonly />
        <van-field v-model="view.lot.manufacturer" label="生产厂家" name="生产厂家" readonly />
        <van-field v-model="view.lot.producingArea" label="产地" name="产地" readonly />
        <van-field v-model="view.detail.receivedQuantity" label="收货数量" name="收货数量" readonly />
        <van-field v-model="view.detail.rejectedQuantity" label="拒收数量" name="拒收数量" readonly />
        <van-field v-model="view.detail.acceptedQuantity" label="验收数量" name="验收数量" readonly />
        <van-field v-model="view.detail.rejectedQuantityOfAcceptance" label="拒验数量" name="拒验数量" readonly />
        <van-button type="primary" @click="itemClick(view)">确认</van-button>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
  import { getUser } from '@/pdaView/utils'

  export default {
    data() {
      return {
        username: getUser().name,
        activeNames: [],
        list: []
      }
    },
    activated() {
      this.refresh()
    },
    methods: {
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      onClickLeft() {
        this.$router.back()
      },
      refresh() {
        this.list = this.$route.params.details
      },
      itemClick(view) {
        this.$router.push({ name: 'Inspect', params: { detail: view } })
      }
    }
  }
</script>